import '@/router/hooks';
import Vue from 'vue'
import Vuex from 'vuex';
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/index';
import vuetify from '@/plugins/vuetify';
import '@/plugins/axios';
import './assets/js/prefs_bbva.js'
import Constants from '@/plugins/constants'
import EventBus from '@/plugins/event-bus';

const VMask = require('v-mask').default;

Vue.use(EventBus);
 
Vue.use(VMask);
Vue.use(Vuex);
Vue.use(Constants);

Vue.prototype.$eventBus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
